import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { getConsultantClientAccessLockMessage } from '../utils/consultantClientUtils';

/**
 * Shown when the current org is a consultant end client that cannot be used yet
 * (awaiting activation or the client's own order-form subscription).
 */
const ConsultantClientAccessBanner = ({ orgDetails, consultantAdmin }) => {
  const message = getConsultantClientAccessLockMessage(orgDetails);
  if (!message) return null;

  return (
    <div
      className='flex flex-wrap items-center justify-between gap-3 border-b border-border bg-warning-bg px-4 py-2 text-sm text-warning'
      role='status'>
      <span className='font-medium text-foreground'>{message}</span>
      {consultantAdmin && (
        <Button asChild size='sm' variant='outline'>
          <Link to='/consultant/portfolio'>Open Client Portfolio</Link>
        </Button>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  orgDetails: state.organisation?.details,
  consultantAdmin: state.profile?.details?.consultantAdmin,
});

export default connect(mapStateToProps)(ConsultantClientAccessBanner);
